import MarkerCollection from '@/lib/map-control/collection/MarkerCollection';
import { isIncludedCurrentFilter } from '../helper';
export default class StoreMarkerCollection extends MarkerCollection {
    /**
     * 상점 마커 추가
     * @param storeData
     * @param dropMarkerCollection
     * @returns
     */
    addMarker(storeData, dropMarkerCollection) {
        const { mapControlState, orderFilter, } = this.hubControlMap;
        const { mapVisibilitySetting, } = mapControlState;
        const { isHideShareOrder, isHideStoreMarker, } = mapVisibilitySetting;
        const { storeId, items, } = storeData;
        const mkStore = this.createMarker(this.mapControl.marker.STORE, storeData);
        // 기존 데이터 동기화 프로세스
        const oldMarker = this.getMarker(storeId);
        mkStore.relatedWeight = oldMarker ? oldMarker.relatedWeight : 0;
        // 이벤트 등록
        this.naver.maps.Event.addListener(mkStore.getNaverMarker, 'click', (value) => {
            this.clickCallback(value.overlay.origin);
        });
        super.add(mkStore.id, mkStore);
        // 도착지 추가
        let greaterThenZero = false;
        Object.values(items).forEach((orderData) => {
            const { isShareOrder, statusCode, isAccepted, } = orderData;
            dropMarkerCollection.addMarker(orderData);
            // 공유주문숨김시 공유 상점은 제외
            if (isShareOrder && isHideShareOrder && isAccepted) {
                return;
            }
            // 필터 판단
            if (isIncludedCurrentFilter(statusCode, orderFilter)) {
                greaterThenZero = true;
            }
        });
        // 지도 노출 여부 프로세스
        const pos = mkStore.getPosition();
        // 상점마커 노출 여부. 상점마커 숨김 설정 활성화 시에는 상점마커 보이지 않기
        const isShow = !isHideStoreMarker && greaterThenZero && this.bounds.hasBounds(pos);
        if (isShow) {
            mkStore.setMap(this.mapInstance);
        }
        else {
            mkStore.setMap(null);
        }
        return mkStore;
    }
}
